import React, { useEffect, useState } from "react";
import {
    CardNumberElement,
    CardExpiryElement,
    CardCvcElement,
    useStripe,
    useElements,
    Elements,
} from "@stripe/react-stripe-js";
import Input from "component/ui/Input";
import AddCardForm from "pages/profile/paymentMethods/addCardForm";

const CheckoutForm = ({ setBookingStatus, fetchCardsList }) => {
    const [showAddCard, setShowAddCard] = useState(false);
    const [loader, setLoader] = useState(false);

    return (
        <div
            className="bg-white rounded-xl w-96 p-4 relative"
            onClick={(e) => e.stopPropagation()}
        >
            {/* Header */}
            <div className="flex items-center mb-4">
                <button
                    onClick={() => setBookingStatus(2)}
                    className="mr-3 text-gray-600 hover:text-black"
                >
                    ←
                </button>
                <h2 className="text-lg font-semibold">Add Card</h2>
                <button
                    onClick={() => setBookingStatus(0)}
                    className="absolute top-4 right-4 w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center"
                >
                    ✕
                </button>
            </div>

            <AddCardForm
                setLoader={setLoader}
                loader={loader}
                fetchCardsList={fetchCardsList}
                setShowAddCard={setShowAddCard}
            />
        </div>
    );
};

const styles = {
    form: {
        maxWidth: "420px",
        padding: "20px",
        borderRadius: "8px",
        backgroundColor: "#fff",
    },
    heading: {
        textAlign: "center",
        marginBottom: "20px",
    },
    label: {
        marginBottom: "6px",
        display: "block",
        fontWeight: "500",
    },
    inputBox: {
        padding: "12px",
        border: "1px solid #ccc",
        borderRadius: "6px",
        marginBottom: "14px",
    },
    row: {
        display: "flex",
        gap: "12px",
    },
    col: {
        flex: 1,
    },
    input: {
        width: "100%",
        padding: "12px",
        borderRadius: "6px",
        border: "1px solid #ccc",
        marginBottom: "14px",
    },
    select: {
        width: "100%",
        padding: "12px",
        borderRadius: "6px",
        border: "1px solid #ccc",
        marginBottom: "14px",
    },
    button: {
        width: "100%",
        padding: "12px",
        backgroundColor: "#5469d4",
        color: "#fff",
        border: "none",
        borderRadius: "6px",
        fontSize: "16px",
        cursor: "pointer",
    },
    error: {
        color: "#fa755a",
        marginBottom: "12px",
    },
};

export default CheckoutForm;
